import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { CASE_STUDIES_FULL } from "../../data/caseStudies";

export default function CaseStudies() {
  const items = CASE_STUDIES_FULL.slice(0, 3);
  return (
    <section
      id="case-studies"
      className="py-20 md:py-28 bg-zinc-50 border-y border-zinc-200"
      data-testid="case-studies-section"
    >
      <div className="container">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-12">
          <div className="lg:col-span-8">
            <p className="text-overline text-electric mb-3">06 — Case Studies</p>
            <h2 className="font-display text-4xl md:text-5xl font-extrabold text-charcoal text-balance">
              Real apps. Real ASO ranks. Real revenue lifts.
            </h2>
          </div>
          <Link
            to="/case-studies"
            data-testid="all-cases-link"
            className="lg:col-span-4 lg:justify-self-end inline-flex items-center gap-2 text-charcoal font-semibold hover:text-electric"
          >
            View all case studies <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200">
          {items.map((c, idx) => (
            <motion.article
              key={c.slug}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="group"
              data-testid={`case-study-${idx}`}
            >
              <Link
                to={`/case-studies/${c.slug}`}
                className="bg-white p-7 md:p-8 flex flex-col h-full hover:bg-charcoal hover:text-white transition-colors"
              >
                <div className="flex items-center justify-between mb-6">
                  <span className="text-overline text-electric">{c.category}</span>
                  <ArrowUpRight className="w-4 h-4 text-zinc-400 group-hover:text-white" />
                </div>
                <div className="font-display text-5xl md:text-6xl font-black text-electric leading-none mb-2">
                  {c.metric}
                </div>
                <p className="text-sm uppercase tracking-widest text-zinc-500 group-hover:text-zinc-300 mb-6">
                  {c.metricLabel}
                </p>
                <h3 className="font-display text-xl md:text-2xl font-bold leading-tight">
                  {c.title}
                </h3>
                <p className="mt-3 text-[15px] text-zinc-600 group-hover:text-zinc-300 leading-relaxed">
                  {c.summary}
                </p>
                <div className="mt-auto pt-6 flex items-center gap-2 text-xs text-zinc-500 group-hover:text-zinc-300">
                  <MapPin className="w-3.5 h-3.5" /> {c.market}
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
